import Transport, { limit, offset } from '../../common/services/api/Transport';

const transport = new Transport();

export const createUser = async userData => {
    try {
        const result = await transport.post({ path: `users`, data: userData });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const getUsers = async pageNumber => {
    try {
        const result = await transport.get({ path: `users?limit=${limit}&offset=${offset(pageNumber)}` });
        return result.data.statusCode === 200
            ? { ...result.data.data, count: Math.ceil(result.data.data.count / limit) }
            : {};
    } catch (error) {
        return null;
    }
};

export const getUsersList = async () => {
    try {
        const result = await transport.get({ path: `users-list` });
        return result.data.statusCode === 200 ? result.data.data.users : [];
    } catch (error) {
        return null;
    }
};

export const getUser = async userId => {
    try {
        const result = await transport.get({ path: `users/${userId}` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const getUsersAcl = async () => {
    try {
        const result = await transport.get({ path: `users/acl` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const updateUser = async userData => {
    try {
        const result = await transport.put({ path: `users/${userData._id}`, data: userData });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

export const deleteUser = async userId => {
    try {
        const result = await transport.delete({ path: `users/${userId}` });
        return result.data.statusCode === 200 ? result.data.data : {};
    } catch (error) {
        return null;
    }
};

const getPorosysTokenHeader = () => ({
    'X-Porosys-Token': sessionStorage.getItem('porosysToken') || '',
});

export const syncCompareUsers = async () => {
    try {
        const result = await transport.get({
            path: 'users/sync/compare',
            config: {
                headers: getPorosysTokenHeader(),
            },
        });

        if (result.data.statusCode === 200) {
            return { success: true, data: result.data.data };
        }

        return {
            success: false,
            message: result.data.userMessage || 'خطا در همگام‌سازی کاربران',
        };
    } catch (error) {
        const responseData = error.response?.data;
        return {
            success: false,
            message: responseData?.userMessage || responseData?.developerMessage || 'خطا در همگام‌سازی کاربران',
        };
    }
};

export const syncImportUsers = async users => {
    try {
        const result = await transport.post({
            path: 'users/sync/import',
            data: { users },
        });
        return result.data.statusCode === 200 ? { success: true, data: result.data.data } : { success: false };
    } catch (error) {
        return { success: false };
    }
};

export const syncDeleteUsers = async userIds => {
    try {
        const result = await transport.post({
            path: 'users/sync/delete',
            data: { userIds },
        });
        return result.data.statusCode === 200 ? { success: true, data: result.data.data } : { success: false };
    } catch (error) {
        return { success: false };
    }
};
